<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="640" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-6 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            {{ group && group.id ? 'Editar' : 'Crear' }} {{ group && group.parent_id ? 'subgrupo' : 'grupo' }}
          </h2>
        </div>
        <div class="flex-shrink-0">
          <!-- <b-dropdown aria-role="list" position="is-bottom-left">
            <template #trigger="{ active }">
                <b-button
                    label="Acciones"
                    type="is-primary"
                    icon-pack="fas"
                    size="is-small"
                    :icon-right="active ? 'chevron-up' : 'chevron-down'" />
            </template>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('scheduled')">Recalcular progreso programado</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('inspected')">Recalcular progreso inspeccionado</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('all')">Recalcular todo</b-dropdown-item>
          </b-dropdown> -->
        </div>
      </header>

      <!-- BODY con fondo blanco liso -->
      <div class="px-6 py-5 space-y-4 bg-white">

        <div class="w-full pb-3">
          <div class="mt-4">
            <b-field :label="$t('groups') + ' padre'">
              <treeselect v-model="groupParent"
                :multiple="false"
                :options="groups"
                :disabled="!form.id && !!form.parent_id"
              />
            </b-field>
          </div>

          <div class="mt-4">
            <l-form-input
              v-model="form.code"
              ref="code"
              :form="form"
              field="code"
              label="code"
            />
          </div>

          <div class="mt-4">
            <l-form-input ref="name"
              :form="form"
              field="name"
              label="name"
            />
          </div>

          <div class="mt-4">
            <label for="weight" class="label">
              {{ $t('weight') }}
            </label>
            <l-form-input
              v-model="form.weight"
              ref="weight"
              :form="form"
              field="weight"
            />
          </div>

          <div class="mt-4">
            <b-field :label="$t('is_discipline')">
              <b-switch
                v-model="form.is_discipline"
                :true-value="1"
                :false-value="0"
              >
                {{ $t(form.is_discipline ? 'yes' : 'no') }}
              </b-switch>
            </b-field>
          </div>

          <div class="mt-4">
            <!-- <label for="color" class="label">
              {{ $t('color') }}
            </label>
            <l-form-input
              v-model="form.color"
              ref="color"
              :form="form"
              field="color"
            /> -->
            <b-field label="Select a color">
              <b-colorpicker
                v-model="selectedColor"
                :color-formatter="formatter"
                :alpha="hasAlpha"
                expanded
                position="is-top-right"
              />
            </b-field>

          </div>

        </div>
      </div>

      <!-- FOOTER sin fondo gris, solo borde superior -->
      <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-end space-x-2">
          <form @submit.prevent="sendGroupData" @keydown="form.onKeydown($event)" v-if="!processingData"
            class="w-full flex items-center justify-end mb-2 mt-2">
            <v-button color="grey" icon="undo-alt" @click="isModalActive = false">{{ $t('cancel') }}</v-button>
            <v-button :disabled="disableSaveButton" type="submit" icon="thumbs-up" icon-pack="far" class="mr-4">{{ $t('save') }}</v-button>
          </form>

          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import Color from 'buefy/src/utils/color'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Form from "vform";

export default {
  name: "activity-group-edit-modal",

  components: {
    Color,
    Treeselect
  },

  props: {
    entityType: { type: String, required: true },
    entityId: { type: Number, required: true },
  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,

      disableSaveButton: false,
      processingData: false,
      group: null, // grupo seleccionado

      form: new Form({  // data activity or subactivity of template project
        id: null,
        entity_type: this.entityType,
        parent_id: null,
        code: '',
        name: '',
        weight: null,
        is_discipline: 0,
        // configs: this.group ? this.group.configs : {},
        color: null,
      }),

      format: 'hex',
      selectedColor: null,
      groups: [], // grupos de actividades
      groupParent: null, // grupo de actividad seleccionada
    }
  },

  computed: {
    hasAlpha() {
      return /a\s*$/i.test(this.format)
    }
  },

  created() {
    this.getGroupsList()
  },

  methods: {

    async getGroupsList() {
      let params = {
        template: 'select'
      };

      const { data } = await axios.get(
        "/api/v2/project/" + this.entityId + "/activity/groups",
        { params: params }
      );

      if (data && data.success) {
        this.groups = data.groups;
      } else {
        this.$notify.error("error_loading_extra_fields_data");
      }
    },

    async getGroupsData() {
      const { data } = await axios.get('/api/v2/activity/groups/' + this.form.id, {params: { with_statuses: 1 }})
      if (data && data.success) {
        this.form.id = data.data.id
        this.form.parent_measurement_id = data.data.parent_measurement_id
        this.form.unit_id = data.data.unit_id
        this.form.code = data.data.code
        this.form.name = data.data.name
        this.form.weight = data.data.weight
        this.form.is_discipline = Number(data.data.is_discipline) === 1 ? 1 : 0

      } else {
        this.$notify.error('error_loading_measurement_data')
      }
    },

    async sendGroupData() {
      this.processingData = true

      var url = `/api/v2/project/${this.entityId}/activity/groups`;
      let isCreate = ! this.form.id // si id es null o cero es crear el grupo
      if( !isCreate )
        url = `/api/v2/activity/groups/${this.form.id}`; // se edita el grupo

      this.form.parent_id = typeof this.groupParent === 'undefined' ? null : this.groupParent
      this.form.color = this.formatter(this.selectedColor) === '#000000' ? null : this.formatter(this.selectedColor)

      const { data } = await this.form.post(url).catch((error) => { this.processingData = false })

      if (data && data.success) {

        this.$notify.success('success_editing')

        if( data.warning )
          this.$notify.warning(data.warning)

        this.processingData = false
        this.$emit('epc-success-creating', this.entity)
      } else {
        this.processingData = false
        if( data && data.message )
          this.$notify.error(data.message)
        else
          this.$notify.error('error_creating_group')
      }
    },

    formatter (color) {
      return color.toString(this.format)
    },

    show(data) {
      this.group = data;

      this.form.id = data ? data.id : null,
      // this.form.entity_type = this.entityType,
      this.form.parent_id = data ? data.parent_id : null,
      this.form.code = data ? data.code : '',
      this.form.name = data ? data.name : '',
      this.form.weight = data ? data.weight : null,
      this.form.is_discipline = data && Number(data.is_discipline) === 1 ? 1 : 0,
      // this.form.configs: data ? data.configs : {},
      this.form.color = data && data.color ? data.color : null,

      this.selectedColor =  Color.parse(data && data.color ? data.color : null);
      this.groupParent = data ? data.parent_id : null;

      // this.fetchActivityGroupProgress({filter_type: 'default'});
      this.isModalActive = true;
    },

    hide() {
      this.group = null;

      this.form.id = null;
      this.form.parent_id = null;
      this.form.code = '';
      this.form.name = '';
      this.form.weight = null;
      this.form.is_discipline = 0;
        // this.form.configs: {},
      this.form.color = null;

      this.isModalActive = false;

    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
